/** Extract up to 2 uppercase initials from a name string. */
export function getInitials(name: string): string {
	if (!name.trim()) return "?";
	return name
		.split(" ")
		.map((w) => w[0])
		.join("")
		.toUpperCase()
		.slice(0, 2);
}
